const sidebarLinks = [
  {
    name: "Home",
    type: "home",
    link: "/account",
    img: "/images/home.png",
    img2: "/images/home2.png",
  },
  {
    name: "Digital Gold",
    type: "gold",
    active: "/dashboard/gold",
    link: "/dashboard/gold/buy",
    img: "/images/gold_shield.png",
  },
  {
    name: "Digital Silver",
    type: "silver",
    active: "/dashboard/silver",
    link: "/dashboard/silver/buy",
    img: "/images/silver_shield.png",
  },
  {
    name: "History",
    type: "history",
    link: "/dashboard/history",
    img: "/images/historyHome.png",
    img2: "/images/history2.png",
  },
  {
    name: "Portfolio",
    type: "portfolio",
    link: "/dashboard/portfolio",
    img: "/images/portfolioHome.png",
    img2: "/images/portfolio2.png",
  },
  {
    name: "Profile",
    type: "profile",
    link: "/dashboard/profile",
    img: "/images/profileHome.png",
    img2: "/images/profile2.png",
  },
];

export default sidebarLinks;
